import { render } from "./Formulario.vue?vue&type=template&id=66415d9e&ts=true"
import script from "./Formulario.vue?vue&type=script&lang=ts"
export * from "./Formulario.vue?vue&type=script&lang=ts"

import "./Formulario.vue?vue&type=style&index=0&id=66415d9e&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__